const t = /* @__PURE__ */ new Map();
function n(e) {
  t.clear();
  for (const a of e)
    t.set(a.tag, {
      displayName: a.displayName || a.tag,
      parts: a.parts.map((s) => ({
        component: a.tag,
        part: s.part,
        description: s.description ?? "",
        displayName: s.displayName || s.part,
        // Only parts the asset declared overridable reach here, so the flag is
        // what carries them through the designer-facing filters.
        cxOverridable: !0
      }))
    });
}
function o() {
  t.clear();
}
function r() {
  return t;
}
export {
  n as a,
  o as c,
  r as s
};
//# sourceMappingURL=session-parts-CfRSgvd1.js.map
